import api from '../../config/APIConfig';

const { iAxios, apiUri } = api;

const baseUrl = `${apiUri}/v1`;

export const PagoFAOActions = {
    seleccionarPlan
    ,DatosFacturacion
    ,seleccionarPlanUpdate
}
function seleccionarPlan(personaPlan) {
    return iAxios.post(`${baseUrl}/DatosPlan`,personaPlan)
}
function seleccionarPlanUpdate(personaPlan) {
    return iAxios.post(`${baseUrl}/DatosPlanUpdate`,personaPlan)
}
function DatosFacturacion(obj) {
    return iAxios.post(`${baseUrl}/DatosFacturacion`,obj)
}